import { useContext } from "react";
import useSWRMutation from "swr/mutation";
import { environment } from "../config/environment";
import { ToastContext } from "../context/ToastContext";
import { useSWRFetcher } from "./useSWRFetcher";

export const useUpdateChasable = (id: string | undefined) => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);

  const { trigger, isMutating, error } = useSWRMutation(
    id ? `${environment.apiUrl}/api/chasables/${id}` : null,
    (url: string, { arg }: { arg: { plannedDate: string } }) =>
      fetcher(url, {
        method: "PUT",
        body: JSON.stringify(arg),
      }),
    {
      onError: () => {
        showToast("Failed to update promise to pay date, please try again later", "error");
      },
    }
  );

  return {
    updateChasable: trigger,
    isLoading: isMutating,
    isError: !!error,
  };
};
